import { createContext, useContext } from 'react';

const GridModeContext = createContext(false);

export const useGridMode = () => useContext(GridModeContext);
export const GridModeProvider = GridModeContext.Provider;
export default GridModeContext;
